
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-0a974a18\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!./libelles.scss")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./libelles.ts"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0a974a18\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./libelles.vue.html"),
  /* scopeId */
  "data-v-0a974a18",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/libelles/libelles.vue.html
// module id = VNyl
// module chunks = 2